import * as rootObject from './';

const DEFAULT_FILTER = {
	filter: "SHOW_ALL",
	start: null,
	end: null
}

export const getFilter = (state, label) => {
  return {...rootObject.getCars(state)[label].history.filter};
}

export default (state = DEFAULT_FILTER, action) => {
  let newState = {...state};
  switch (action.type) {
    case 'SET_VISIBILITY_FILTER': console.log(action)
      return {filter: action.filter, start:action.start||null, end:action.end||null }
    default:
      return newState
  }
}


// WEBPACK FOOTER //
// ./src/reducers/filter.js